export function modalInit() {
  eventInit();
}

const eventInit = () => {
  const cardsArray = document.querySelectorAll('.section_card_modalDownload__singleCard');
  
  cardsArray.forEach((element) => {
    const modalBox = element.querySelector('.section_card_modalDownload__modal');
    const modalBoxInner = element.querySelector('.section_card_modalDownload__modalBox');
    const closeButton = element.querySelector('.section_card_modalDownload__modalClose');

    element.addEventListener('click', () => openModal(modalBox));

    closeButton.addEventListener('click', (event) => {
      event.stopPropagation();
      closeModal(modalBox);
    })

    modalBox.addEventListener('click', (event) => {
      event.stopPropagation();
      closeModal(modalBox);
    }, false)

    modalBoxInner.addEventListener('click', (event) => event.stopPropagation());
  });
}

const openModal = (modalBox) => modalBox.classList.add('active');
const closeModal = (modalBox) => modalBox.classList.remove('active');